// @ts-nocheck
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Input } from '@/components/ui/input';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SectionCard from './SectionCard';

// Full IANA zone list on modern engines; a curated US-centric fallback otherwise.
const TIME_ZONE_OPTIONS = (() => {
  try {
    if (typeof Intl.supportedValuesOf === 'function') {
      return Intl.supportedValuesOf('timeZone');
    }
  } catch (e) { /* fall through */ }
  return [
    'America/Los_Angeles', 'America/Denver', 'America/Phoenix', 'America/Chicago',
    'America/New_York', 'America/Anchorage', 'Pacific/Honolulu', 'UTC',
  ];
})();

export default function ScheduleSection({ d }) {
  const { draft, setField, dirtyBySection, savingSection, saveSection } = d;

  return (
    <SectionCard
      id="schedule"
      title="Registration Access"
      description="When sign-ups open and close, and who can access the form. The page stays publicly viewable either way."
      dirty={dirtyBySection.schedule}
      saving={savingSection === 'schedule'}
      onSave={() => saveSection('schedule')}
    >
      <div className="space-y-2 rounded-lg border p-4">
        <div className="flex items-center gap-2">
          <Switch
            id="gate-start"
            checked={!!draft.gateByStartDate}
            onCheckedChange={(v) => setField('gateByStartDate', v)}
          />
          <Label htmlFor="gate-start" className="text-base font-medium">Set registration start date</Label>
        </div>
        <p className="pl-10 text-sm text-muted-foreground">
          Users can view the registration but can&apos;t sign up until this date &amp; time.
        </p>
        {draft.gateByStartDate && (
          <div className="space-y-1 pl-10 pt-1">
            <Label htmlFor="reg-start" className="text-sm font-medium">Registration opens</Label>
            <Input
              id="reg-start"
              type="datetime-local"
              className="max-w-xs"
              value={draft.registrationStartDate || ''}
              onChange={(e) => setField('registrationStartDate', e.target.value)}
            />
          </div>
        )}
      </div>

      <div className="space-y-2 rounded-lg border p-4">
        <div className="flex items-center gap-2">
          <Switch
            id="gate-end"
            checked={!!draft.gateByEndDate}
            onCheckedChange={(v) => setField('gateByEndDate', v)}
          />
          <Label htmlFor="gate-end" className="text-base font-medium">Set registration end date</Label>
        </div>
        <p className="pl-10 text-sm text-muted-foreground">
          New sign-ups stop after this date &amp; time. Teams already registered can still be viewed and edited.
        </p>
        {draft.gateByEndDate && (
          <div className="space-y-1 pl-10 pt-1">
            <Label htmlFor="reg-end" className="text-sm font-medium">Registration closes</Label>
            <Input
              id="reg-end"
              type="datetime-local"
              className="max-w-xs"
              value={draft.registrationEndDate || ''}
              onChange={(e) => setField('registrationEndDate', e.target.value)}
            />
          </div>
        )}
      </div>

      <div className="space-y-2 rounded-lg border p-4">
        <Label htmlFor="access-code" className="text-base font-medium">Access code</Label>
        <p className="text-sm text-muted-foreground">
          Optional. When set, players must enter this code before they can access the registration form.
        </p>
        <Input
          id="access-code"
          type="text"
          className="max-w-xs"
          value={draft.accessCode || ''}
          onChange={(e) => setField('accessCode', e.target.value)}
          placeholder="e.g. nikkei2026"
          autoComplete="off"
        />
        <p className="text-xs text-muted-foreground">Leave blank to keep registration open to anyone with the link.</p>
      </div>

      {(draft.gateByStartDate || draft.gateByEndDate) && (
        <div className="space-y-2 rounded-lg border p-4">
          <Label htmlFor="reg-tz" className="text-base font-medium">Time zone</Label>
          <p className="text-sm text-muted-foreground">
            The open and close date/times above are interpreted and shown in this time zone.
          </p>
          <Select
            id="reg-tz"
            value={draft.registrationTimeZone || ''}
            onChange={(e) => setField('registrationTimeZone', e.target.value)}
            displayEmpty
            className="max-w-xs"
            sx={{ minWidth: 280 }}
          >
            {TIME_ZONE_OPTIONS.map((tz) => (
              <MenuItem key={tz} value={tz}>{tz}</MenuItem>
            ))}
          </Select>
        </div>
      )}
    </SectionCard>
  );
}
